import { Component, Prop, Vue } from "vue-property-decorator";
import _Template from "./style.vue";
import * as $ from "jquery";
import service from "@/service/index";
import DzMenu from "../dzMenu";
import eventBus from "@/util/eventBus";

interface ISelectItem {
  frame ?:string;
  explain ?:string;
}

@Component({
  mixins: [_Template],
})
export default class PowerList extends Vue {
  @Prop({ default: {} })
  selectPowerData;

  public isMainMenuWrapperShow: boolean = false;

  public defPowerList: ISelectItem[] = [
    {
     frame : 'mine',
     explain : '我的业绩',
    },
    {
      frame : 'shop',
      explain : '店铺业绩',
    }
  ];
  public selectItem: ISelectItem = {};

  // 菜单 点击事件
  public onMenuItemClick(e, item) {
    this.isMainMenuWrapperShow = false;
    this.selectPower(item);
  }
  public showMenu() {
    this.isMainMenuWrapperShow = true;
  }

  public selectPower(item) {
    const { frame,explain } = item;
    this.selectItem = item;
    $("#powerSelect").text(explain);
    this.selectPowerData(frame);
    $(".guider-list").hide();
    $(".popupMask").hide();
  }

  mounted() {
    eventBus.on("taskCenterOnSelectPower", item => {
      this.selectPower(item);
    });
  }

  render(h) {
    return (
      <div class="data-select-wrap">
        <div class="data-select">
          <span
            onClick={() => {
              this.showMenu();
            }}
            class="date-text"
            id="powerSelect"
          >
            {this.defPowerList[0].explain}
          </span>

          <i class="iconfont icon-moreunfold" style="position: static;color:#2c3e50;" />

          <DzMenu
            label="explain"
            v-model={this.isMainMenuWrapperShow}
            menuItems={this.defPowerList}
            onMenuItemClick={(e, item) => this.onMenuItemClick(e, item)}
          />
        </div>
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/home/gitlab-runner/builds/8fef9614/0/saas-extend/qingger-dz-webview/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-cc797f36/index.tsx" });